import { render, staticRenderFns } from "./addNewStore.vue?vue&type=template&id=3dcbabb5&scoped=true&"
import script from "./addNewStore.vue?vue&type=script&lang=js&"
export * from "./addNewStore.vue?vue&type=script&lang=js&"
import style0 from "./addNewStore.vue?vue&type=style&index=0&id=3dcbabb5&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcbabb5",
  null
  
)

export default component.exports